<template>
    <div class="container">
        <div class="py-4">
            <div class="row">
                <div class="card-deck">
                    <div class="col-sm-12 col-md-6 col-lg-4 h-100" v-for="(ref,i) in referenzen" :key="i">
                        <card :title="'<i class=\'icon-bracket\'></i>' + ref.title" :img="ref.img" class="h-100">

                            <p class="card-text" v-html="ref.text"></p>
                            <span slot="footer">
                                <tag class="mr-1" v-for="tag in ref.tags" :key="tag">{{tag}}</tag>
                            </span>
                            <a slot="" :href="ref.link" target="_blank" class="btn btn-primary">
                                Zur Seite →
                            </a>

                        </card>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center my-5">
                <div ref="button" title="Kommt bald … wirklich" class="d-inline-block">
                    <button disabled class="btn btn-outline-primary btn-lg">Alle Referenzen →</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            referenzen: [{
                img: require('@/assets/projects/dnp.png'),
                title: 'Deutscher Nach&shy;haltig&shy;keits&shy;preis',
                text: `Webseite des deutschen Nachhaltigkeitspreises aus Düsseldorf.
                Entwickelt mit modernen Responsive-Technologien in TYPO3`,
                link: 'https://www.nachhaltigkeitspreis.de/',
                tags: ['TYPO3', 'Vue.JS', 'Docker']
            },{
                img: require('@/assets/projects/lunchbox-2.png'),
                title: 'Lunchbox.koeln',
                text: `Urban Deli aus Köln-Ehrenfeld. Konzeption und Entwicklung Speisekarten-Applikation, Bestellmaske und API
                auf Basis des Symfony 4 Frameworks. Cloud-Hosting betrieb mit Docker und AWS.
                `,
                link: 'https://www.lunchbox.koeln',
                tags: ['Symfony 4', 'Vue.JS', 'Docker']
            }, {
                img: require('@/assets/projects/troy.png'),
                title: 'troy gmbh',
                text: `Webseite der troy gmbh - Entwiklung responsive design ..... TBD`,
                link: 'https://www.troy-bleiben.de',
                tags: ['Vue.JS', 'Wordpress']
            }]
        }
    },
    mounted() {
        $(this.$refs.button).tooltip()
    }
}
</script>
